module.exports = __webpack_public_path__ + "static/media/cover.40cfab75.png";